import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
// import rocketLaunch from "Assets/Images/Images/rocket-launch.png";
import type { RootStateType } from "State/Store";
import { setSignUpSubsidy } from "State/Voucher/VoucherReducer";
import { formatCurrency } from "Utils/CurrencyUtils";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

// const StyledRocketLaunch = styled.img`
//   width: 100%;
// `;

const StyledDialog = styled(Dialog)`
  .MuiPaper-root {
    border-radius: 0;
    ${(props) => props.theme.breakpoints.down("sm")} {
      width: 280px;
    }
    ${(props) => props.theme.breakpoints.up("sm")} {
      width: 350px;
    }
  }

  .MuiDialogContent-root {
    padding: 0;
  }
`;

const TextWrapper = styled.div`
  padding: ${(props) => props.theme.spacing(2)};
`;

export const SignUpSubsidyPopup = () => {
  const { signUpSubsidy } = useSelector((e: RootStateType) => e.voucher);

  const dispatch = useDispatch();

  if (signUpSubsidy === null) {
    return null;
  }

  const handleClose = () => {
    dispatch(setSignUpSubsidy(null));
  };

  return (
    <>
      <StyledDialog fullWidth={true} open={true} onClose={handleClose}>
        <DialogContent>
          <div>
            {/* <StyledRocketLaunch src={rocketLaunch} alt="Moone" /> */}
          </div>

          <TextWrapper>
            <Typography fontSize="20px" fontWeight={700}>
              Něco do začátku…
            </Typography>
            <Typography component="div">
              Aby byl Váš vstup do Moone příjemnější, již vám připisujeme
              prvních
              <Box component="strong" mx={1}>
                {formatCurrency({
                  amount: signUpSubsidy.fiatAmount,
                  currencyCode: signUpSubsidy.currencyCode,
                })}
              </Box>
              v bitcoinech na Váš účet. Věříme, že toto bude začátek dlouhé
              cesty.
            </Typography>
          </TextWrapper>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Pokračovat</Button>
        </DialogActions>
      </StyledDialog>
    </>
  );
};
